import { UniformSlot } from "@uniformdev/canvas-react";

import { Button } from "@/libraries/design/components";
import { CallToAction } from "@/libraries/design/patterns";
import { CallToActionBackgroundColors } from "@/libraries/design/patterns/call-to-action/src/call-to-action";
import { useLocalizedHref } from "@/libraries/web-framework/index.ts";

export type UniformCallToActionProps = {
    title: string;
    description?: string;
    ctaText?: string;
    ctaUrl?: string;
    backgroundColor?: CallToActionBackgroundColors;
};

export const UniformCallToAction = (props: UniformCallToActionProps) => {
    const localizedHref = useLocalizedHref(props.ctaUrl ?? "");

    const button = () => {
        if (
            props.ctaText &&
            props.ctaText !== "" &&
            props.ctaUrl &&
            props.ctaUrl !== ""
        ) {
            return <Button href={localizedHref}>{props.ctaText}</Button>;
        }
        return;
    };

    return (
        <CallToAction
            header={props.title}
            paragraph={props.description}
            button={button() ?? <UniformSlot name="ctaButton" />}
            backgroundColor={props.backgroundColor}
        />
    );
};

export default UniformCallToAction;
